<template>
    <b-card id="edicaoItensVencedoresLoteLicitacao" class="mx-5" bg-variant="light" no-body>
        <template #header>
            <h6 class="mb-0 titulo-sagres font-weight-bold">
                Itens do Lote
            </h6>
        </template>
        <b-table :fields="fieldsItens" :items="itensLote" :busy="tableBusyItens" :current-page="currentPageItens" hover
            no-border-collapse striped small sort-by="" stacked="sm" responsive show-empty>
            <template #empty>
                <span>Não foram encontrados dados.</span>
            </template>
            <template #emptyfiltered>
                <span>Não foram encontrados dados.</span>
            </template>
            <template #table-busy>
                <div class="text-center text-dark">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong class="loading-text">Carregando...</strong>
                </div>
            </template>
        </b-table>
        <table-pagination v-if="totalRowsItens > pageSize" :total-rows="totalRowsItens" :per-page="pageSize"
            class="ml-3 mb-1" :firstCurrentPg="currentPageItens" @pageChange="pageChange" />
    </b-card>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'
import ldiService from '@/services/licitacoes/ldiService'
import { mixins } from 'vue-class-component'
import { UtilsTS } from '@/utilsts'
import { TableField } from '@/types/table-field'
import TablePagination from "@/components/atos-pessoal/TablePagination.vue"
import { fieldsItemLoteVencedorLicitacao } from '@/types/licitacoes/ldi/fields-item-licitacao'
import { ItemLicitacao } from '@/types/licitacoes/ldi/item-licitacao'
import { LoteLicitacao } from '@/types/licitacoes/ldi/lote-licitacao'

const CompProps = Vue.extend({
    name: 'DetalhesItensVencedoresLoteLicitacao',
    components: { TablePagination },
    props: {
        idLote: {
            type: Number,
            required: true
        }
    }
})

@Component
export default class DetalhesItensVencedoresLoteLicitacao extends mixins(UtilsTS, CompProps) {
    fieldsItens: TableField[] = fieldsItemLoteVencedorLicitacao
    itensLote: ItemLicitacao[] = []
    pageSize = 5
    currentPageItens = 1
    totalRowsItens = 0
    tableBusyItens = false
    lote: LoteLicitacao | null = null

    async mounted() {
        this.loadData()
    }

    async loadData() {
        try {
            this.tableBusyItens = true
            this.lote = await ldiService.buscarLotePorId(this.idLote)

            const response = await ldiService.buscarItensLote(this.idLote, this.currentPageItens, this.pageSize)
            if (response) {
                this.itensLote = response.itensLote.map(l => {
                    const item = Object.assign(new ItemLicitacao(), l)
                    return item
                })
                this.totalRowsItens = response.totalRows
                //console.log('load data itensLote: ', this.itensLote)
            } else {
                this.$toast.error('Erro ao consultar os itens do lote desta licitação.');
            }
            //console.log("itensLote", this.itensLote)
        } finally {
            this.tableBusyItens = false;
        }
    }
    async pageChange(value) {
        this.currentPageItens = value;
        await this.loadData();
    }
}


</script>